import React, {lazy, Suspense} from 'react'
import {Switch, Route} from 'react-router-dom'
import {Typography} from 'antd'
import typo from "../../constants/dictionaries";
const {Title} = Typography;

// Components
const GS = lazy(() => import('./index'));
const TNN = lazy(() => import('./Logs_TNN/index'));

export default ({match}) => {
  const groupName = 'quan-tri-he-thong'
  return (
    <Suspense fallback={() => <Title level={4}>Loading</Title>}>
      <Switch>
        <Route exact path={`${match.path}/giam-sat`} component={GS}/>
        <Route exact path={`${match.path}/tai-nguyen-nuoc`} component={TNN}/>
      </Switch>
    </Suspense>
  )
}